//load fallback banner if adbox fails to load (for example, because of an ad blocker)
export default async function () {
    const bannerEl = document.querySelector('#page_mr13');
    const fallbackBannerEl = document.querySelector('#page_mr13_fallback');

    function loadFallbackBanner() {
        if (bannerEl.style.display === 'none') {
            fallbackBannerEl.style.display = 'flex';
        }
    }

    //hide fallback banner if adbox banner is loaded after 4 seconds (for example user waits long time in CMP banner)
    function observeBannerDisplay() {
        if (!window.MutationObserver) return; // Fallback for very old browsers

        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
                    var display = window.getComputedStyle
                        ? window.getComputedStyle(bannerEl, null).getPropertyValue('display')
                        : bannerEl.currentStyle
                            ? bannerEl.currentStyle.display
                            : bannerEl.style.display;

                    if (display !== 'none') {
                        fallbackBannerEl.style.display = 'none';
                        observer.disconnect();
                    }
                }
            });
        });

        observer.observe(bannerEl, { attributes: true, attributeFilter: ['style'] });
    }
    observeBannerDisplay();

    //if adbox banner still not loaded after 5 seconds, load fallback banner
    let timeoutReached = false;
    const timeoutTimer = setTimeout(() => {
        loadFallbackBanner();
        timeoutReached = true;
    }, 4000);

    const interval = setInterval(() => {
        if (
            (window.inxBX?.failed && bannerEl.style.display === 'none') || timeoutReached
        ) {
            clearInterval(interval);
            clearTimeout(timeoutTimer);
            loadFallbackBanner();
        }
    }, 200);
}